var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6673 17.0007C33.6673 26.2054 26.2054 33.6673 17.0007 33.6673C7.79591 33.6673 0.333984 26.2054 0.333984 17.0007C0.333984 7.79591 7.79591 0.333984 17.0007 0.333984C26.2054 0.333984 33.6673 7.79591 33.6673 17.0007ZM11.95 11.9501C12.4382 11.4619 13.2296 11.4619 13.7178 11.9501L17.0006 15.2329L20.2834 11.9501C20.7715 11.4619 21.563 11.4619 22.0511 11.9501C22.5393 12.4383 22.5393 13.2297 22.0511 13.7179L18.7684 17.0006L22.0511 20.2834C22.5393 20.7715 22.5393 21.563 22.0511 22.0511C21.5629 22.5393 20.7715 22.5393 20.2833 22.0511L17.0006 18.7684L13.7178 22.0512C13.2297 22.5393 12.4382 22.5393 11.9501 22.0512C11.4619 21.563 11.4619 20.7716 11.9501 20.2834L15.2328 17.0006L11.95 13.7178C11.4619 13.2297 11.4619 12.4382 11.95 11.9501Z",
    fill: "#F34F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/Incorrect.b59efc0f86bf0ecd75179285134d1861.svg";
export { ForwardRef as ReactComponent };